import { render, staticRenderFns } from "./BookOverview.vue?vue&type=template&id=ad8b8ff6&"
import script from "./BookOverview.vue?vue&type=script&lang=js&"
export * from "./BookOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports